import type { TicketStatusCategory } from '@/types';

const statusConfig: Record<TicketStatusCategory, { label: string; className: string }> = {
  open: { label: 'Open', className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300' },
  pending: { label: 'Awaiting your reply', className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300' },
  on_hold: { label: 'On hold', className: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300' },
  solved: { label: 'Solved', className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' },
  closed: { label: 'Closed', className: 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300' },
};

interface TicketStatusBadgeProps {
  statusCategory: TicketStatusCategory;
}

export function TicketStatusBadge({ statusCategory }: TicketStatusBadgeProps) {
  const config = statusConfig[statusCategory] || statusConfig.open;

  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  );
}
